import { toast } from "react-toastify";

import Share from "@/Components/Icons/Share";
import { OutlinedButton } from "@/Components/v2/atoms/Button";
import { Tooltip } from "@/Components/v2/atoms/ToolTip";

export const ShareButton: React.FC = () => {
  const handleClick = () => {
    const url = location.href;
    navigator.clipboard.writeText(url);
    toast.success("Link copied!");
  };

  return (
    <Tooltip title="Copy URL" placement="bottom">
      <span>
        <OutlinedButton onClick={handleClick} startIcon={<Share />} variant="outlined" size="large">
          Share
        </OutlinedButton>
      </span>
    </Tooltip>
  );
};
